import { render, staticRenderFns } from "./tiyouyouPackageList.vue?vue&type=template&id=2e953eed&"
import script from "./tiyouyouPackageList.vue?vue&type=script&lang=js&"
export * from "./tiyouyouPackageList.vue?vue&type=script&lang=js&"
import style0 from "./tiyouyouPackageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports